import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/settings/")({
  beforeLoad: () => {
    // oxlint-disable-next-line typescript-eslint/only-throw-error: TanStack Router requires throwing redirect objects
    throw redirect({ to: "/settings/team" });
  },
});
